import { productCategories } from '../../../mocks/products';

const quickLinks = [
  { label: 'Featured Products',   href: '#featured'      },
  { label: 'How to Choose',       href: '#how-to-choose' },
  { label: 'Product Lineup',      href: '#products'      },
  { label: 'Markets Served',      href: '#markets'       },
  { label: 'Why Surface Solutions of CT',        href: '#why-choose'    },
  { label: 'Technology',          href: '#technology'    },
  { label: 'Request Info',        href: '#contact'       },
];

const FooterSection = () => {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#0e0e0e' }} className="border-t border-white/6">

      {/* Conversion banner */}
      <div className="bg-[#c9a84c]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-14 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <i className="ri-shield-check-fill text-[#0a0a0a] text-[22px] flex-shrink-0" />
            <div>
              <p className="text-[#0a0a0a] font-black text-[14px] tracking-[0.04em]">Surface Solutions of CT — Authorized Reseller</p>
              <p className="text-[#0a0a0a]/55 text-[11px]">Direct access to the complete Nano Pro Ceramic® product line</p>
            </div>
          </div>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="flex-shrink-0 px-7 py-3 bg-[#060606] text-[#c9a84c] text-[11px] font-black tracking-[0.16em] hover:bg-[#111] transition-colors cursor-pointer whitespace-nowrap"
          >
            CONTACT AN AUTHORIZED RESELLER
          </a>
        </div>
      </div>

      {/* Main body */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-14 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/84733ff0-c80f-453c-bb88-cea233922c90/07dce610-2d48-4487-af00-c98d564b8bed_surface-solutions-grey-logo-trans.png?v=7fff9acbc8304034587aa88e0c4fd1fe"
                alt="Surface Solutions of CT"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/30 text-[12px] leading-[1.85]">
              Authorized reseller of NanoPro® Ceramic Coatings — providing professional-grade surface protection products for automotive, marine, aviation, and residential applications.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white/45 text-[10px] tracking-[0.25em] font-bold mb-6 uppercase">Quick Links</h4>
            <ul className="flex flex-col gap-3.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-white/35 text-[13px] hover:text-white/65 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Product categories */}
          <div>
            <h4 className="text-white/45 text-[10px] tracking-[0.25em] font-bold mb-6 uppercase">Product Categories</h4>
            <ul className="flex flex-col gap-3.5">
              {productCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={`#${cat.anchor}`}
                    onClick={(e) => { e.preventDefault(); scrollTo(`#${cat.anchor}`); }}
                    className="text-white/35 text-[13px] hover:text-white/65 transition-colors cursor-pointer"
                  >
                    {cat.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/45 text-[10px] tracking-[0.25em] font-bold mb-6 uppercase">NANOPRO® HQ</h4>
            <div className="flex flex-col gap-5">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-2-fill text-[#c9a84c] text-[14px] mt-0.5 flex-shrink-0" />
                <p className="text-white/35 text-[12px] leading-relaxed">3549 High Ridge Rd<br />Boynton Beach, FL 33426<br />United States</p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-fill text-[#c9a84c] text-[14px] flex-shrink-0" />
                <a href="tel:5616314085" className="text-white/35 text-[12px] hover:text-white/55 transition-colors cursor-pointer">561-631-4085</a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-fill text-[#c9a84c] text-[14px] flex-shrink-0" />
                <a href="mailto:contact@nanoproceramic.com" className="text-white/35 text-[12px] hover:text-white/55 transition-colors cursor-pointer">contact@nanoproceramic.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-14 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/18 text-[11px]">© 2026 Surface Solutions of CT — Authorized Reseller of NanoPro® Ceramic Coatings</p>
          <p className="text-white/14 text-[10px] text-center">
            NANOPRO® and BOROPHENE BY NANOPRO® are registered trademarks of the USPTO. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
